export default "/_next/static/images/choose_any_style-e6b8b9f712a7ec3799f2d5dbf267000b.png";